import { lazy } from "react";
import Loadable from "../components/Loadable";
const Login = Loadable(lazy(() => import("../views/Auth/Login")));
const OptLogin = Loadable(lazy(() => import("../views/Auth/OtpLogin")));
const Register = Loadable(lazy(() => import("../views/Auth/Register")));
const ForgetPass = Loadable(lazy(() => import("../views/Auth/ForgetPass")));
const Instructions = Loadable(lazy(() => import("../views/Instructions")));
const CallRequest = Loadable(lazy(() => import("../views/Auth/CallRequest")));
const ApiUserRegister = Loadable(
  lazy(() => import("../views/Auth/ApiUserRegister"))
);
const ResetPassword = Loadable(
  lazy(() => import("../views/Auth/ResetPassword"))
);
const SubscribeEmail = Loadable(
  lazy(() => import("../views/Auth/SubscribeEmail"))
);
const UnSubscribeEmail = Loadable(
  lazy(() => import("../views/Auth/UnSubscribeEmail"))
);
export const authRoutes = [
  { path: "/login", component: Login },
  { path: "/otp-verify", component: OptLogin },
  { path: "/register", component: Register },
  { path: "/forgot-pass", component: ForgetPass },
  { path: "/instructions", component: Instructions },
  { path: "/call-request", component: CallRequest },
  { path: "/register-api-user", component: ApiUserRegister },
  { path: "/reset-password/:user_id/:securityToken", component: ResetPassword },
  { path: "/subscribe/:userId/:securityToken", component: SubscribeEmail },
  { path: "/unsubscribe/:userId/:securityToken", component: UnSubscribeEmail },
];
